import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import InviteUserModal from './InviteMemberModal'
import AllMembers from './AllMembers'
import Requests from './Requests'
import ViewRoleDetailsModal from './ViewRoleDetailsModal'
import DashboardHeader from '../common/DashboardHeader/DashboardHeader'
import Breadcrumb from '../common/Breadcrumb'
import WrappedTabs from '../common/WrappedTabs'
import SimpleButton from '../common/SimpleButton'
import { useLocalStorage } from '../../hooks/useLocalStorage'
import { drAuthRules } from '../../utils/drConfig'
import { hasCorporateAdminModulesPermission } from '../../utils/permissionValidation'
import { loadUserCompany } from '../../actions/userCompany'
import { COLTENE_BRANCH_UUID } from '../../actions/root'
import './members.scss'

const Members = (props) => {
  const { t } = useTranslation()
  const location = useLocation()
  const navigationTab = location.state?.activeTab
  const isCorporateAdmin = hasCorporateAdminModulesPermission(props.userPermissions)
  const [colteneBranchId] = useLocalStorage(COLTENE_BRANCH_UUID)

  const isBranchAdminUser = props.userBranches?.find((branch) => branch.branchUuid === colteneBranchId)?.email === props.userEmail
  const hasEditAccess = !isCorporateAdmin || (isCorporateAdmin && isBranchAdminUser)

  const [activeTab, setActiveTab] = useState(null)
  const [showInviteUserModal, setShowInviteUserModal] = useState(false)
  const [showRoleDetails, setShowRoleDetails] = useState(false)

  const tabs = [
    {
      key: 0,
      title: 'dealer-portal.active_members',
      content: <AllMembers showRoleDetails={() => setShowRoleDetails(true)} hasEditAccess={hasEditAccess} />,
    },
    {
      key: 1,
      title: 'dealer-portal.requests',
      content: <Requests showRoleDetails={() => setShowRoleDetails(true)} hasEditAccess={hasEditAccess} />,
    },
  ]

  useEffect(() => {
    setActiveTab(tabs[navigationTab || 0])
  }, [])

  useEffect(() => {
    props.actions.loadUserCompany()
  }, [props.actions])

  const handleChangeTab = (tabKey) => {
    const tab = tabs.find((tab) => tab.key === tabKey)
    setActiveTab(tab)
  }

  return (
    <div className="members-wrapper">
      <Breadcrumb path={window.location.pathname} />
      <DashboardHeader headerText={t('nav.members')}>
        {hasEditAccess && (
          <SimpleButton className="submit-button" onClick={() => setShowInviteUserModal(true)} disabled={!drAuthRules.isCompanyAccountUpdateAllowed}>
            {t('dealer-portal.invite_member')}
          </SimpleButton>
        )}
      </DashboardHeader>
      <WrappedTabs tabs={tabs.map((tab) => ({ id: tab.key, name: tab.title }))} activeTab={activeTab?.key} changeTab={handleChangeTab} />
      {activeTab?.content && activeTab.content}

      {showInviteUserModal && <InviteUserModal closeModal={() => setShowInviteUserModal(false)} showRoleDetails={() => setShowRoleDetails(true)} />}
      {showRoleDetails && <ViewRoleDetailsModal closeModal={() => setShowRoleDetails(false)} />}
    </div>
  )
}

function mapStateToProps({ authedUser, userPermissions, userCompany }) {
  return {
    userPermissions,
    userEmail: authedUser?.email || '',
    userBranches: userCompany?.userBranches || [],
  }
}

function dispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        loadUserCompany,
      },
      dispatch,
    ),
  }
}

export default connect(mapStateToProps, dispatchToProps)(Members)

